/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { CloseBtn } from '../CloseBtn'
import { RevertBtn } from '../RevertBtn'
import { RpChipPanel } from '../RpChipPanel'
import { TotalDepositBox } from '../TotalDepositBox'
import { Ante } from './Ante'
import { Bet } from './Bet'
import { Bonus } from './Bonus'
import {
  BetWrapper,
  BoxBetActions,
  Container,
  ContainerWrapper,
} from './styles'

export const SelectedBoxView: FC<{ box: BoxStore }> = observer((props) => {
  const {
    sumStake,
    bet,
    hasStake,
    sendRollbackLastStake,
    sendRollbackAllStakes,
    seatNumber,
  } = props.box

  return (
    <ContainerWrapper>
      <RpChipPanel {...props} />
      <Container
        css={css`
          box-shadow: 0 0 8px 0 rgba(178, 155, 106, 0.13),
            15px 0 60px 0 rgba(255, 196, 69, 0.2);
        `}>
        <TotalDepositBox deposit={sumStake} />
        <BetWrapper>
          <Bonus selected {...props} />
          <Ante selected {...props} />
          <Bet selected={false} amount={bet} />
        </BetWrapper>
        <BoxBetActions disabled={!hasStake}>
          <CloseBtn
            onClick={sendRollbackAllStakes}
            data-cy={`rp-rollbackAllStakes-btn-${seatNumber}`}
          />
          <RevertBtn
            onClick={sendRollbackLastStake}
            data-cy={`rp-rollbackLastStake-btn-${seatNumber}`}
          />
        </BoxBetActions>
      </Container>
    </ContainerWrapper>
  )
})
